import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
    acronym: (field?: string) => [
        validations.required.text(field),
        validations.pattern.numericValuesNotAllow(),
        validations.min.text(2),
    ],
    accessCodeCount: (field?:any) => [
        validations.required.text(field),
        validations.pattern.numeric
    ],
    startDate: (field?: string) => [validations.required.text(field)],
    endDate: (field?: string) => [validations.required.text(field)],
};
